import {
  PERFILES_UPDATE_ROLE_BEGIN,
  PERFILES_UPDATE_ROLE_SUCCESS,
  PERFILES_UPDATE_ROLE_FAILURE,
  PERFILES_UPDATE_ROLE_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW } from '../../../common/config';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function updateRole(id, body) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PERFILES_UPDATE_ROLE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.put(REACT_APP_API_ABM_FW + "/roles/" + id, body);
      doRequest.then(
        (res) => {
          if (res.data.success) {
            dispatch({
              type: PERFILES_UPDATE_ROLE_SUCCESS,
              data: res,
            });
            resolve(res);
          } else {
            dispatch({
              type: PERFILES_UPDATE_ROLE_FAILURE,
              data: { error: res.data.errorMessage },
            });
            reject(res.data.errorMessage);
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PERFILES_UPDATE_ROLE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissUpdateRoleError() {
  return {
    type: PERFILES_UPDATE_ROLE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PERFILES_UPDATE_ROLE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateRolePending: true,
        updateRoleError: null,
      };

    case PERFILES_UPDATE_ROLE_SUCCESS:
      // The request is success
      return {
        ...state,
        updateRolePending: false,
        updateRoleError: null,
      };

    case PERFILES_UPDATE_ROLE_FAILURE:
      // The request is failed
      return {
        ...state,
        updateRolePending: false,
        updateRoleError: action.data.error,
      };

    case PERFILES_UPDATE_ROLE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateRoleError: null,
      };

    default:
      return state;
  }
}
